export default "__VITE_ASSET__9be5ccb9__"